import SoftBox from "components/SoftBox";
import ResetContextButton from "./ResetContextbutton";
import FilterButton from "./FilterButton";
import SearchButton from "./SearchButton";
import CopyButton from "./CopyButton";

const ContextHeaderActions = ({ editorRef }) => {
  return (
    <SoftBox sx={{ display: "flex", marginTop: 1 }}>
      <SoftBox sx={{ display: "flex" }}>
        <SearchButton editorRef={editorRef} />
        <FilterButton />
        <ResetContextButton />
        <CopyButton editorRef={editorRef} />
      </SoftBox>
      {/* <CloseContext /> */}
    </SoftBox>
  );
};

export default ContextHeaderActions;
